/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * The specification of asymmetric key-pair.
 *
 * | Truvity | JWX - KeyType | JWX - Curve | FIPS  | SEC2      | OpenSSL    | AWS KMS       |
 * |---------|---------------|-------------|-------|-----------|------------|---------------|
 * | ED25519 | OKP           | Ed25519     |       |           | ed25519    |               |
 * | P256    | EC            | P-256       | P-256 | secp256r1 | prime256v1 | ECC_NIST_P256 |
 * | P384    | EC            | P-384       | P-384 | secp384r1 | secp384r1  | ECC_NIST_P384 |
 *
 * Useful third-party documentation:
 * - [openssl-genrsa - generate an RSA private key](https://www.openssl.org/docs/manmaster/man1/openssl-genpkey.html).
 * - [openssl-ec, ec - EC key processing](https://www.openssl.org/docs/man1.0.2/man1/ec.html)
 * - [openssl-genrsa - generate an RSA private key](https://www.openssl.org/docs/man3.0/man1/openssl-genrsa.html)
 * - [openssl-pkcs8 - PKCS#8 format private key conversion command](https://www.openssl.org/docs/manmaster/man1/openssl-pkcs8.html)
 * - [JWX - github.com/lestrrat-go/jwx](https://github.com/lestrrat-go/jwx/blob/main/cmd/jwx/README.md)
 * - [FIPS 186-4](https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.186-4.pdf).
 * - [SEC2](https://www.secg.org/sec2-v2.pdf).
 * - [AWS KMS - Asymmetric key specs](https://docs.aws.amazon.com/kms/latest/developerguide/asymmetric-key-specs.html)
 * .
 */
export type KeyPublicType = 'ED25519' | 'P256' | 'P384';
export const KeyPublicType = {
    Ed25519: 'ED25519',
    P256: 'P256',
    P384: 'P384',
} as const;
